import {
  call,
  cancel,
  cancelled,
  fork,
  put,
  select,
  take,
  takeLatest
} from 'redux-saga/effects';

import { selectContentFromAppState, selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { SelectAll, SpaceContentsRequest } from '../../app/actions/AppActionTypes';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import {
  addToContentSelection,
  deselectAll,
  startSelection,
  stopSelection,
} from '../actions/ContentExplorerSelectionActions';
import { requestSpaceContentsMissingSlice } from '../actions/RequestSpaceContentsActions';
import {
  PAGESIZE_SLICE,
  processRequestSpaceContentMissingSliceInner
} from './content/MixedContentSagas';


export function* rootContentSelectionSaga() {
  yield takeLatest(SelectAll, handleSelectAllWithCancellation);
}

export function* handleSelectAllWithCancellation() {
  const task = yield fork(handleSelectAllInner);

  yield take([ SpaceContentsRequest ]);
  yield cancel(task);
  yield put(stopSelection());
}

export function* handleSelectAllInner() {
  try {
    yield put(startSelection());
    yield put(deselectAll());

    const totalLength = yield select(selectContentTotalLength);

    // Run the "request missing slice" saga to fetch all the items in the current view
    const requestMissingSlicesAction = requestSpaceContentsMissingSlice(0, totalLength);
    yield call(processRequestSpaceContentMissingSliceInner, PAGESIZE_SLICE, requestMissingSlicesAction);

    // Add the content to the selection after it's all fetched (rather than incrementally)
    // so the user doesn't think the selection is ready before everything is actually loaded.
    const allContent = yield select(selectContentFromAppState);
    yield put(addToContentSelection(...allContent));

  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  } finally {
    if (yield cancelled()) {
      yield put(deselectAll());
    }
    yield put(stopSelection());
  }
}
